// extracted by mini-css-extract-plugin
export var black = "_4o-6";
export var brand = "_4o-1";
export var ddefault = "_4o-0";
export var error = "_4o-3";
export var gray = "_4o-2";
export var highContrast = "_4o-8";
export var outline = "_4o-7";
export var success = "_4o-5";
export var warning = "_4o-4";